import { LinkingOptions } from "@react-navigation/native";
import { Platform } from "react-native";
import STO from "../config/companies/STO";
import delivery from "../config/companies/delivery";
import hotel from "../config/companies/hotel";
import { AuthParamList, RootStackParamList } from "../types/navigationParams";

type AppLinkingParamList = RootStackParamList & AuthParamList;

const companyConfigs = [STO, delivery, hotel];

const staticDrawerScreens = {
  SettingsScreen: "settings",
  EmployeesScreen: "employees",
  JoinCompanyScreen: "join-company",
};

const configuredDrawerScreens = companyConfigs.reduce<Record<string, string>>(
  (acc, config) => {
    config.screens.forEach((screen) => {
      acc[screen.name] = screen.name;
    });

    return acc;
  },
  {},
);

const drawerLinkingConfig = {
  path: "drawer",
  screens: {
    ...staticDrawerScreens,
    ...configuredDrawerScreens,
  },
} as const;

const prefixes =
  Platform.OS === "web" ? ["/", "tizimapp://"] : ["tizimapp://"];

export const linking: LinkingOptions<AppLinkingParamList> = {
  prefixes,
  config: {
    screens: {
      Drawer: drawerLinkingConfig as never,
      SignInScreen: "signin",
      RegisterScreen: "signup",
      CreateCompanyScreen: "create-company",
      NewEmployeeForm: "new-employee",
      FormScreen: "form/:collection",
      DetailsScreen: "details/:collection/:id",
      PickerScreen: "picker",
      CollectionPickerScreen: "collection-picker",
      CreateRentScreen: "create-rent",
      ChatScreen: "chat/:chatId",
      JoinCompanyScreen: "join-company",
      EmployeeDetailsScreen: "employee/:id",
      PaymentsFormScreen: "payments/:collection",
      ReportsScreen: "reports",
      ConfigManagement: "ConfigManagement",
    },
  },
};
